import { Component } from '@angular/core';

/**
 * Thin application shell: just hosts the router outlet. The dashboard lives at the
 * '' route (AppComponent) and Claudia is lazy-loaded at '/claudia'. This component
 * is what index.html's <app-root> bootstraps.
 */
@Component({
  selector: 'app-root',
  template: '<router-outlet></router-outlet>',
})
export class RootComponent {}
